import { GroupOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function EmptyBlockedUsersOverlay() {
  return (
    <NoRowsOverlay
      icon={GroupOutlinedIcon}
      title='ยังไม่มีรายชื่อผู้ไม่มีสิทธิ์สอบ'
      // TODO: uncomment this code and implement add blocked users feature here
      // description='คลิกปุ่มด้านล่างเพื่อเพิ่มรายชื่อใหม่'
      // action={
      //   <Button startIcon={<AddIcon />} size='large' variant='outlined'>
      //     เพิ่มรายชื่อ
      //   </Button>
      // }
    />
  );
}
